export var FITDATAIDS;
(function (FITDATAIDS) {
  FITDATAIDS["formJS"] = "form_JS";
  // listJS = 'list_JS',
  // listData = 'listData',
  FITDATAIDS["anyData"] = "anyData";
  FITDATAIDS["rvListJS"] = "rv_list_JS";
  FITDATAIDS["rvFormJS"] = "rv_form_JS";
})(FITDATAIDS || (FITDATAIDS = {}));
export const fitDataIdKey = 'ds:fitDataId';
export const btnIcon = 'https://vfiles.gtimg.cn/vupload/20210427/938d481619528238025.png';
//# sourceMappingURL=consts.js.map
